export default "__VITE_ASSET__C0V7kYE0__"